import { render, staticRenderFns } from "./ProjectLockOverlay.vue?vue&type=template&id=1b4607c4&scoped=true&"
import script from "./ProjectLockOverlay.vue?vue&type=script&lang=js&"
export * from "./ProjectLockOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLockOverlay.vue?vue&type=style&index=0&id=1b4607c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4607c4",
  null
  
)

export default component.exports